var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("6. props setting")]),_c('h6',[_vm._v("props in `/assets/index.esm.js`")]),_c('markdown-it-vue',{staticClass:"md-body",staticStyle:{"height":"500px","overflow-y":"scroll"},attrs:{"content":_vm.getIntexEsmJs,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }